import momentTz from 'moment-timezone/builds/moment-timezone-with-data-10-year-range';
import { createJsonAdapter } from './jsonAdapter';

export interface IActivityRow {
  id: number;
  descriptions?: string | null;
  dateTime: string;
  repeatType: string;
  repeatWeekOn?: number[] | null;
  isNotificationAdmin?: boolean;
  isNotificationSenior?: boolean;
}

export const ACTIVITY_REPEAT_TYPES = ['ONCE', 'DAILY', 'WEEKLY', 'MONTHLY', 'YEARLY'];

const str = (value: unknown) => String(value ?? '').trim();

// An activity's date/time are the senior's local ones: the backend converts them with the
// senior's zone, and `dateTime` comes back as an instant that is shown in that same zone.
export const createActivityAdapter = (timezone: string) =>
  createJsonAdapter<IActivityRow>({
    url: 'events',
    rowToForm: (row) => {
      const start = momentTz.tz(row.dateTime, timezone);

      return {
        descriptions: row.descriptions ?? '',
        date: start.format('YYYY-MM-DD'),
        time: start.format('HH:mm'),
        repeatType: row.repeatType ?? 'ONCE',
        // Sunday = 0 .. Saturday = 6, as the app sends it
        repeatWeekOn: (row.repeatWeekOn ?? []).join(','),
        isNotificationSenior: row.isNotificationSenior ?? false,
        isNotificationAdmin: row.isNotificationAdmin ?? false,
      };
    },
    toBody: (form) => ({
      descriptions: str(form.descriptions),
      date: str(form.date),
      time: str(form.time),
      repeatType: str(form.repeatType) || 'ONCE',
      repeatWeekOn:
        form.repeatType === 'WEEKLY' ? str(form.repeatWeekOn).split(',').filter(Boolean).map(Number) : [],
      isNotificationSenior: form.isNotificationSenior === true,
      isNotificationAdmin: form.isNotificationAdmin === true,
    }),
  });
